<template>
  <div>
    <div v-if="erro" class="alert alert-danger" role="alert">{{ erro }}</div>
    <!-- MODO NORMAL: exibe formulário de data e botão -->
    <div v-if="!props.printMode">
      <h6>{{ props.printTitle }}</h6>
      <p></p>

      <!-- Formulário de parâmetro (data) -->
      <div class="row mb-3">
        <div class="col-auto">
          <label>Data:</label>
          <input type="date" v-model="data" class="form-control" />
        </div>
        <div class="col-auto align-self-end">
          <button @click="abrirPrint" class="btn btn-primary" :disabled="!validClosingDate(data)">
            Executar
          </button>
        </div>
      </div>
    </div>

    <!-- MODO IMPRESSÃO: exibe título + data + tabelas e totais -->
    <div v-else>
      <!-- 1) Título e data -->
      <h6 v-if="data" class="text-center mb-3">
        Data: {{ formatarData(data) }}
      </h6>

      <!-- 2) Loading -->
      <div v-if="loading" class="mb-3">
        Carregando…
      </div>

      <!-- 3) Caso não haja nada nos três blocos -->
      <div v-else-if="saveData && !A.length && !B.length && !C.length && !D.length">
        <p>Nenhum registro encontrado.</p>
      </div>


      <!-- --- BLOCO A --- -->
      <div v-if="!loading && saveData && A.length">
        <h6>Vencimentos Gerados e Pagos nesta Data</h6>
        <p></p>
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th>Vencimento</th>
              <th>Pagamento</th>
              <th>Prev. Receb.</th>
              <th class="text-right">Valor</th>
              <th>Forma de Pagamento</th>
              <th>Autorização</th>
              <th>Refil</th>
              <th>Descrição</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, idx) in A" :key="idx">
              <td>{{ row.registro_id }}</td>
              <td>{{ formatCell(row.data_vencimento, 'data_vencimento') }}</td>
              <td>{{ formatCell(row.data_pagamento, 'data_pagamento') }}</td>
              <td>{{ formatCell(row.recebimento_previsto, 'data_recebimento') }}</td>
              <td class="text-right">{{ formatCell(row.valor, 'valor') }}</td>
              <td>{{ row.forma_pagamento }}</td>
              <td>{{ row.numero_autorizacao || '—' }}</td>
              <td>{{ row.refil }}</td>
              <td>{{ row.descricao }}</td>
            </tr>
          </tbody>
          <!-- Rodapé com total A -->
          <tfoot>
            <tr>
              <td colspan="3"><strong>Total A</strong></td>
              <td class="text-right"><strong>{{ formatarMoeda(totalA) }}</strong></td>
              <td colspan="4"></td>
            </tr>
          </tfoot>
        </table>
      </div>

      <!-- --- BLOCO B --- -->
      <div v-if="!loading && saveData && B.length" class="mt-4">
        <h6>Vencimentos Gerados nesta Data com Pendência</h6>
        <p></p>
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th>Vencimento</th>
              <th>Pagamento</th>
              <th>Prev. Receb.</th>
              <th class="text-right">Valor</th>
              <th>Forma de Pagamento</th>
              <th>Autorização</th>
              <th>Refil</th>
              <th>Descrição</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, idx) in B" :key="idx">
              <td>{{ row.registro_id }}</td>
              <td>{{ formatCell(row.data_vencimento, 'data_vencimento') }}</td>
              <td>{{ formatCell(row.data_pagamento, 'data_pagamento') }}</td>
              <td>{{ formatCell(row.recebimento_previsto, 'data_recebimento') }}</td>
              <td class="text-right">{{ formatCell(row.valor, 'valor') }}</td>
              <td>{{ row.forma_pagamento }}</td>
              <td>{{ row.numero_autorizacao || '—' }}</td>
              <td>{{ row.refil }}</td>
              <td>{{ row.descricao }}</td>
            </tr>
          </tbody>
          <!-- Rodapé com total B -->
          <tfoot>
            <tr>
              <td colspan="3"><strong>Total B</strong></td>
              <td class="text-right"><strong>{{ formatarMoeda(totalB) }}</strong></td>
              <td colspan="4"></td>
            </tr>
          </tfoot>
        </table>
      </div>

      <!-- --- BLOCO C --- -->
      <div v-if="!loading && saveData && C.length" class="mt-4">
        <h6>Vencimentos Pendentes e Pagos nesta Data</h6>
        <p></p>
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th>Vencimento</th>
              <th>Pagamento</th>
              <th>Prev. Receb.</th>
              <th class="text-right">Valor</th>
              <th>Forma de Pagamento</th>
              <th>Autorização</th>
              <th>Refil</th>
              <th>Descrição</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, idx) in C" :key="idx">
              <td>{{ row.registro_id }}</td>
              <td>{{ formatCell(row.data_vencimento, 'data_vencimento') }}</td>
              <td>{{ formatCell(row.data_pagamento, 'data_pagamento') }}</td>
              <td>{{ formatCell(row.recebimento_previsto, 'data_recebimento') }}</td>
              <td class="text-right">{{ formatCell(row.valor, 'valor') }}</td>
              <td>{{ row.forma_pagamento }}</td>
              <td>{{ row.numero_autorizacao || '—' }}</td>
              <td>{{ row.refil }}</td>
              <td>{{ row.descricao }}</td>
            </tr>
          </tbody>
          <!-- Rodapé com total C -->
          <tfoot>
            <tr>
              <td colspan="3"><strong>Total C</strong></td>
              <td class="text-right"><strong>{{ formatarMoeda(totalC) }}</strong></td>
              <td colspan="4"></td>
            </tr>
          </tfoot>
        </table>
      </div>

      <!-- --- BLOCO D --- -->
      <div v-if="!loading && saveData && D.length" class="mt-4">
        <h6>Cheques Devolvidos nesta Data</h6>
        <p></p>
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th>Devolução</th>
              <th>Vencimento</th>
              <th class="text-right">Valor</th>
              <th>Forma de Pagamento</th>
              <th>Cheque</th>
              <th>Motivo</th>
              <th>Refil</th>
              <th>Descrição</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, idx) in D" :key="idx">
              <td>{{ row.registro_id }}</td>
              <td>{{ formatCell(row.data_devolucao, 'data_devolucao') }}</td>
              <td>{{ formatCell(row.data_vencimento, 'data_vencimento') }}</td>
              <td class="text-right">{{ formatCell(row.valor, 'valor') }}</td>
              <td>{{ row.forma_pagamento }}</td>
              <td>{{ row.cheque_numero || '—' }}</td>
              <td>{{ row.motivo_devolucao || row.observacao_cheque || '—' }}</td>
              <td>{{ row.refil }}</td>
              <td>{{ row.descricao }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="3"><strong>Total D</strong></td>
              <td class="text-right"><strong>{{ formatarMoeda(totalD) }}</strong></td>
              <td colspan="5"></td>
            </tr>
          </tfoot>
        </table>

        <small class="text-muted">
          Total informativo de cheques devolvidos. Este valor não compõe os totais de recebimentos válidos.
        </small>
      </div>

    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import axios from '@/services/axios'
import { validClosingDate, validClosingResponse, closingError } from '@/utils/fechamentoDiario'
const emit = defineEmits(['export-ready'])

// Props vindas da rota de impressão
const props = defineProps({
  printMode:  { type: Boolean, default: false },
  printTitle: { type: String,  default: 'Fechamento Diário de Caixa' }
})

const router = useRouter()
const route  = useRoute()

// Estado para o parâmetro “data”
const data     = ref('')
const loading  = ref(false)
const saveData = ref(false)
const erro = ref('')
let requestId = 0
onBeforeUnmount(() => { requestId++ })

// Cada bloco A, B, C, D e seus respectivos totais
const A      = ref([])
const totalA = ref(0)
const B      = ref([])
const totalB = ref(0)
const C      = ref([])
const totalC = ref(0)
const D      = ref([])
const totalD = ref(0)

/**
 * Busca os dados do Fechamento Diário no back-end,
 * preenchendo A/B/C e totalA/totalB/totalC
 */
async function buscarFechamento() {
  const currentRequest = ++requestId
  emit('export-ready', false)
  erro.value = ''
  saveData.value = false
  if (!validClosingDate(data.value)) {
    A.value = []
    B.value = []
    C.value = []
    D.value = []
    totalA.value = 0
    totalB.value = 0
    totalC.value = 0
    totalD.value = 0
    erro.value = 'Informe uma data válida para consultar o Fechamento Diário.'
    return
  }

  loading.value  = true
  saveData.value = false

  A.value = []
  B.value = []
  C.value = []
  D.value = []
  totalA.value = 0
  totalB.value = 0
  totalC.value = 0
  totalD.value = 0

  try {
    const res = await axios.get(
      '/gestao/relatorios/financeiros/fechamento-diario',
      { params: { data: data.value } }
    )
    if (currentRequest !== requestId) return
    if (!validClosingResponse(res.data)) throw new Error('Resposta inválida de fechamento.')
    // O back-end retorna { A, totalA, B, totalB, C, totalC }
    A.value      = Array.isArray(res.data.A) ? res.data.A : []
    totalA.value = parseFloat(res.data.totalA) || 0

    B.value      = Array.isArray(res.data.B) ? res.data.B : []
    totalB.value = parseFloat(res.data.totalB) || 0

    C.value      = Array.isArray(res.data.C) ? res.data.C : []
    totalC.value = parseFloat(res.data.totalC) || 0

    D.value      = Array.isArray(res.data.D) ? res.data.D : []
    totalD.value = parseFloat(res.data.totalD) || 0
    saveData.value = true
    loading.value = false
    await nextTick()
    if (currentRequest === requestId) emit('export-ready', true)

  } catch (err) {
    if (currentRequest !== requestId) return
    erro.value = closingError(err)
    console.error('Erro ao buscar fechamento diário:', err)
    A.value = []
    B.value = []
    C.value = []
    D.value = []
    totalA.value = 0
    totalB.value = 0
    totalC.value = 0
    totalD.value = 0
  } finally {
    if (currentRequest === requestId) loading.value = false
  }
}

/**
 * Abre a rota de impressão, passando title e data via query param
 */
function abrirPrint() {
  if (!validClosingDate(data.value)) return
  router.push({
    path: `/gestao/relatorios/print/fechamento-diario`,
    query: {
      title: props.printTitle,
      data: data.value
    }
  })
}

// Se estivermos em printMode, já pegamos data da rota e executamos a busca
onMounted(() => {
  if (!props.printMode) return
  data.value = route.query.data || ''
  return buscarFechamento()
})

/**
 * Formatação genérica de células:
 * - chaves contendo “data_” são formatadas como dd/MM/aaaa
 * - chave “valor” é formatada como moeda
 */
function formatCell(valor, chave) {
  if (valor === null || valor === undefined) return ''

  // Formata datas sem nunca tocar em timezone
  if (chave.includes('data_')) {
    // '2025-07-23' ou '2025-07-23T00:00:00Z'
    const [datePart] = String(valor).split('T')
    const [ano, mes, dia] = datePart.split('-')
    return `${dia.padStart(2,'0')}/${mes.padStart(2,'0')}/${ano}`
  }

  // Se for valor monetário
  if (chave === 'valor') {
    return Number(valor).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    })
  }

  return valor
}

// Utilitário para formatar apenas o total como moeda
function formatarMoeda(num) {
  if (num == null) return ''
  return Number(num).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })
}

/**
 * Converte “YYYY-MM-DD” em “dd/MM/YYYY”
 * Para exibir a data abaixo do título
 */
function formatarData(isoDate) {
  if (!isoDate) return ''
  const [ano, mes, dia] = isoDate.split('-')
  return `${dia}/${mes}/${ano}`
}
</script>

<style scoped>
.mb-3 {
  margin-bottom: 1rem;
}
.mt-4 {
  margin-top: 1.5rem;
}
</style>
